import React, { useEffect } from "react";
import Swiper from 'swiper';

import "./style.scss";
import "swiper/css/swiper.min.css";

const Slider = ({content, style}) => {
    useEffect(() => {
        new Swiper('.swiper-container', {
            autoplay: {
                delay: 5000,
            },
            speed: 800,
            watchSlidesProgress: true,
            watchOverflow: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                renderBullet: function (index, className) {
                    return '<span class="' + className + '"><span class="bullet-loader"></span></span>';
                },
            },
        });
        return;
    });
    
    return (
        <section className="slider swiper-container rounded" style={style}>
            <div className="swiper-wrapper">
                {content.map((item, index) => {
                    return (
                        <div key={index} className="swiper-slide" style={{backgroundImage: `url(${item.image})`}}>
                            <strong 
                                style={{color: item.textColor}} 
                                dangerouslySetInnerHTML={{__html: item.text}}
                            ></strong>
                        </div>
                    )
                })}
            </div>
            <div className="swiper-pagination"></div>
        </section>
    )
}

export default Slider
